import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@homeaway/react-buttons';

import Carousel from '../Carousel';
import PropertyCard from './PropertyCard';
import SearchCard from './SearchCard';
import EdapModuleView from '../EdapModuleView';
import { Experiment } from '../Experiment';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';

import {
  SCRATCHPAD_RECENTACTIVITY_VIEWALL_CLICK,
  SCRATCHPAD_RECENTACTIVITY_CONTINUE_CLICK,
  SCRATCHPAD_RECENTACTIVITY_VIEW,
  SCRATCHPAD_CLICK_PREV,
  SCRATCHPAD_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

class Scratchpad extends Component {
  static propTypes = {
    title: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    viewInScratchpad: PropTypes.objectOf(PropTypes.string),
    fetchScratchpad: PropTypes.func.isRequired
  }

  static defaultProps = {
    data: [],
    fetchScratchpad: () => {}
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchScratchpad();
  }

  // Arrow handlers
  handlePreviousClick() {
    triggerEdapEvent(SCRATCHPAD_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(SCRATCHPAD_CLICK_NEXT);
  }

  render() {
    const {
      data,
      title,
      viewInScratchpad
    } = this.props;

    return (
      data && data.length > 0 &&
      <Experiment name={'HA_PTA_HP_RecentActivityOptimizationV2'} report>
        <section className="Content__section">
          <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
            <Carousel
              title={title}
              actionText={viewInScratchpad && viewInScratchpad.text}
              actionHref={viewInScratchpad && viewInScratchpad.href}
              onActionClick={handleEdapClick(SCRATCHPAD_RECENTACTIVITY_VIEWALL_CLICK)}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
            >
              {data.map((hit, index) =>
                hit.isSearch ?
                  <SearchCard
                    {...hit}
                    key={`${hit.searchTerm}-${index}`}
                    searchButton={
                      <Button
                        block
                        label={hit.continueSearchSummary && hit.continueSearchSummary.text}
                        href={hit.continueSearchSummary && hit.continueSearchSummary.href}
                        onClick={handleEdapClick(SCRATCHPAD_RECENTACTIVITY_CONTINUE_CLICK, { lbsUuid: hit.lbsUuid })}
                      />
                    }
                  /> :
                  <PropertyCard
                    {...hit}
                    key={hit.lbsUuid}
                    onClick={handleEdapClick(SCRATCHPAD_RECENTACTIVITY_VIEW, { searchTerm: hit.resolvedLBSName })}
                  />
              )}
            </Carousel>
          </EdapModuleView>
        </section>
      </Experiment>
    );
  }
}

export default Scratchpad;
